<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filters" class="filter-panel fl">
				<!-- <el-form-item :label="$t('news_index.type')" prop="type">
					<el-select v-model="filters.type" class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option :label="$t('index.whole')" value=""></el-option>
						<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in ARTICLE_TYPE" :key="index"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item>
					<el-button type="primary" size="mini" @click="sousuo">{{$t('index.query')}}</el-button>
					<el-button type="" size="mini" @click="chongxzhi">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add()" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" border row-key="id" size="mini">
			<el-table-column prop="image" align="center" :label="$t('news_index.image')">
				<template slot-scope="scope">
					<el-image style="width: 100px; height: 100px" v-if="scope.row.image" :src="scope.row.image" :preview-src-list="[scope.row.image]" fit="contain"></el-image>
					<span v-if="!scope.row.image">{{$t('index.image_wu')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center"  fixed="right" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('index.dialog_title')" width="800px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('news_index.image')" prop="image">
							<upload :value="editForm.image" name="search" @callback="function(res, file){imageSuccess(res, file,'image')}"></upload>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="tree-content" :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('course_index.cate')" prop="cate" data-name="分类">
							<el-cascader v-model="editForm.cate" class="w100" @change="change_cate" :props="props" :options="cateOption"></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('course_index.age')" prop="age" data-name="年龄">
							<el-select v-model="editForm.age" class="w100" clearable :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in age" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
							<el-select v-model="editForm.teacher_id" class="w100" clearable :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="String(item.teacher_id)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('course_index.center')" prop="center_id" data-name="学习中心">
							<el-select v-model="editForm.center_id" class="w100" clearable :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in learnCenter" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.id" v-if="item.course_type==0||item.course_type==1" ></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('course_index.session')" prop="session" data-name="学期">
							<el-select v-model="editForm.session" class="w100" clearable :placeholder="$t('index.pleaseInput')">
								<el-option v-for="(item,index) in SESSION_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('course_index.week')" prop="week" data-name="星期">
							<el-select v-model="editForm.week" class="w100" clearable :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in WEEK_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	computed: {
		props(){
			return{
				value: 'id',
				label: this.lang=='cn'?'name_cn':'name',
				checkStrictly:true
			}
		},
		editFormRules(){
			return{
				image: [{
					required: true,
					message: this.$t('adv_index.message'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		return {
			is_co:sessionStorage.getItem('is_co'),
			image_up: process.env.API_UP,
			list: [],
			editFormVisible: false,
			editForm: {},
			filters: {},
			image:'',
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			cateOption:[],
			WEEK_ARR:[],
			SESSION_ARR:[],
			age:[],
			teacher:[],
			learnCenter:[],
			form:{
				cate_id:'',
				cate_node_id:'',
				age:'',
				teacher_id:'',
				center_id:'',
				session:'',
				week:'',
			}
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			this.$post('getDictionaryValue',{code:'WEEK_ARR,SESSION_ARR'}).then((res) => {
				this.WEEK_ARR = res.WEEK_ARR;
				this.SESSION_ARR = res.SESSION_ARR;
			})
			this.$post('cateOption', {type:'1'}).then((res) => {
				this.cateOption=this.xunhaun(res.show);
			})
			this.$post('courseScreen', {}).then((res) => {
				this.age=res.age;
				this.teacher=res.teacher;
				this.learnCenter=res.learnCenter;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "searchList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		add(data) {
			this.image='';
			if (data) {
				var editForm = JSON.parse(JSON.stringify(data));
				var content = JSON.parse(editForm.content);
				for(var i in this.form){
					editForm[i] = content[i] || '';
				}
				var cate = [];
				if(content.cate_id){
					cate[0] = content.cate_id
				}
				if(content.cate_node_id){
					cate[1] = content.cate_node_id
				}
				editForm['cate'] = cate;
				// if(content.cate_id||content.cate_node_id){
				// 	editForm['cate'] = [content.cate_id,content.cate_node_id];
				// }

				this.editForm = editForm;
			} else {
				this.editForm = {
					image: '',
					cate:[],
					cate_id:'',
					cate_node_id:'',
					age:'',
					teacher_id:'',
					center_id:'',
					session:'',
					week:'',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		change_cate(){
			if(this.editForm.cate&&this.editForm.cate.length){
				this.editForm.cate_id = this.editForm.cate[0];
				this.editForm.cate_node_id = this.editForm.cate[1];
			}else{
				this.editForm.cate_id = '';
				this.editForm.cate_node_id = '';
			}
		},
		// 保存
		editSubmit(editForm) {
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {}
					if(this.image){
						datas['image'] = this.image;
					}
					var content = {};
					for(var i in this.form){
						if(this.editForm[i]){
							content[i] = this.editForm[i]
						}
					}
					datas['content'] = JSON.stringify(content);
					var url = "searchAction";
					var tishi = this.$t('index.add_success');
					if (this.editForm.id) {
						datas['id'] = this.editForm.id;
						tishi = this.$t('index.modify_success');
					}
					this.$post(url, datas).then((res) => {
						this.$message.success(tishi);
						this.editFormVisible = false;
						this.init();
					});
				} else {
					return false;
				}
			})
		},
		imageSuccess(res, file, name) {
			if (res.status == 200) {
				this.editForm[name] = res.data.showname;
				this.image = res.data.savename;
				this.$refs.editForm.clearValidate(name);
			} else {
				this.$message.success(res.message);
			}
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "SearchDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 搜索
		sousuo() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		chongxzhi() {
			this.filters.type = '';
			this.pages.page = 1;
			this.init();
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	/* margin-bottom: 22px; */
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue